import './PropertyInquiryModule.scss'

import { trackActivity } from 'manager/redux/referral'
import {
  selectManagerOpenUrlFeatureEnabled,
  selectManagerSuggestTourFeatureEnabled,
} from 'manager/selectors/manager_selectors'
import React, { Component } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { isEmbedded } from 'common/util/features'
import {
  PROPERTY_TOUR_SCHEDULE_STATUS
} from 'common/constants'

import {
  selectPropertyInquiryRequestedTourStatus,
  selectPropertyInquiryLocation,
  selectPropertyInquiryMLSNumber,
  selectPropertyInquiryImage,
  selectPropertyInquiryTourOpId,
  selectPropertyInquiryRDCLink,
  selectPropertyInquiryTourDateHidden,
  selectIsPropertyInquiryTourConfirmable,
  selectIsPropertyInquiryTourRescheduleable,
  selectAssignmentHash,
  selectIsPropertyInquiryTourSuggestable,
  selectIsPropertyRDCLinkPresent,
  selectPropertyInquiryTitle,
  selectFormattedPropertyInquiryTourDateTime,
  selectAssignmentTransactionHash,
  selectReadableLeadAvailability,
  selectReferralName,
} from 'manager/selectors/referral_selectors'

export const SUPPRESS_SUGGEST_TOUR_HELP_TEXT_KEY = "suppress_suggest_tour_help_text"

export const formatAddress = (address, city, state, zip) => {
    address = (address && address.trim()) ? address.trim() + "\n" : ""

    let addressFields = [city, state, zip];

    return address + addressFields.filter(field => field && field.trim()).join(" ");
}


export class PropertyInquiryModule extends Component {

  state = {
    showSuggestHelpText: window.localStorage.getItem(SUPPRESS_SUGGEST_TOUR_HELP_TEXT_KEY) !== 'true',
  }

  getActions = () => {
    const { isTourConfirmable, isTourRescheduleable, isTourSuggestable, isRDCLinkPresent, suggestTourFeatureEnabled } = this.props
    const buttonArray = []

    if (isEmbedded() && isTourConfirmable) {
      buttonArray.push(<button key="schedule-btn" className="PropertyInquiryModule__button" onClick={this.scheduleTour}>Schedule tour</button>)
    }

    if (isEmbedded() && isTourRescheduleable) {
      buttonArray.push(<button key="reschedule-btn" className="PropertyInquiryModule__button" onClick={this.rescheduleTour}>Reschedule</button>)
    }

    if (suggestTourFeatureEnabled && isTourSuggestable) {
      buttonArray.push(<button key="suggest-btn" className="PropertyInquiryModule__button" onClick={this.suggestTour}>Suggest tour</button>)
    }

    if (isRDCLinkPresent) {
      buttonArray.push(<button key="view-btn" className="PropertyInquiryModule__button" onClick={this.goToRDCView}>{buttonArray.length ? 'View' : 'View listing'}</button>)
    }

    return buttonArray
  }

  scheduleTour = () => {
    const { tourOpId, assignmentHash } = this.props
    window.ReactNativeWebView.postMessage(`tour:schedule,${tourOpId},${assignmentHash}`)
  }

  rescheduleTour = () => {
    const { tourOpId, assignmentHash } = this.props
    window.ReactNativeWebView.postMessage(`tour:reschedule,${tourOpId},${assignmentHash}`)
  }

  suggestTour = () => {
    const { assignmentHash, trackActivity, assignmentTransactionHash } = this.props
    this.handleHideHelpText()
    trackActivity(assignmentTransactionHash, 'suggest-tour')
    window.ReactNativeWebView.postMessage(`tour:suggest,${''},${assignmentHash}`)
  }

  goToRDCView = () => {
    const { link, tourOpId, openUrlFeatureEnabled } = this.props

    if (isEmbedded() && tourOpId) {
      return window.ReactNativeWebView.postMessage(`tour:link,${tourOpId}`)
    } else {
      if (openUrlFeatureEnabled) {
        return window.ReactNativeWebView.postMessage(`open-url:${link}`)
      } else {
        window.open(link, '_blank')
      }
    }
  }

  renderTourDateAndTime = () => {
    const { isTourDateHidden, tourStatus, formattedTourDateTime } = this.props

    if (isTourDateHidden) {
      return (<div className="PropertyInquiryModule__inquiry-details--content">&nbsp;</div>)
    }

    const scheduledOrCompleted = (tourStatus === PROPERTY_TOUR_SCHEDULE_STATUS.SCHEDULED) || (tourStatus === PROPERTY_TOUR_SCHEDULE_STATUS.COMPLETED)

    return (
      <div className="PropertyInquiryModule__inquiry-details--content">
        <div className={`${scheduledOrCompleted && 'PropertyInquiryModule__inquiry-details--scheduled'}`}>
          <i className='fa fa-calendar PropertyInquiryModule__icon'/>{`${formattedTourDateTime} `}
          {scheduledOrCompleted && <i className='fa fa-check'/>}
        </div>
      </div>
    )
  }

  handleHideHelpText = () => {
    window.localStorage.setItem(SUPPRESS_SUGGEST_TOUR_HELP_TEXT_KEY, "true")
    this.setState({
      showSuggestHelpText: false,
    })
  }

  render() {
    const { location, mlsNumber, image, title, isTourSuggestable, suggestTourFeatureEnabled, leadAvailability, referralName } = this.props
    const { showSuggestHelpText } = this.state
    const { address, city, state, zip } = location
    const isImagePresent = !!image

    return (
      <div className="PropertyInquiryModule">
        <div className="PropertyInquiryModule__title">Inquiry Details</div>
        <div className="PropertyInquiryModule__container">
          <div className="PropertyInquiryModule__inquiry-details">
            <div className="PropertyInquiryModule__inquiry-details--title">
              {title}
            </div>
            <div className="PropertyInquiryModule__inquiry-details--columns">
              <div className="PropertyInquiryModule__inquiry-details--leftcol">
                <div>
                  <div className="PropertyInquiryModule__inquiry-details--content">
                    <i className='fa fa-map-marker PropertyInquiryModule__icon'/>{formatAddress(address, city, state, zip)}
                  </div>
                  {this.renderTourDateAndTime()}
                </div>

                <div className="PropertyInquiryModule__inquiry-details--actions">
                  {this.getActions()}
                </div>
              </div>
              <div className="PropertyInquiryModule__inquiry-details--rightcol">
                <div className={`image ${isImagePresent ? '' : 'PropertyInquiryModule__image-placeholder'}`}>
                  { isImagePresent && <img className="image" src={image}/>}
                  { mlsNumber && <div className="mls"> {`MLS ${mlsNumber}`} </div> }
                </div>
              </div>
            </div>
            { showSuggestHelpText && isTourSuggestable && suggestTourFeatureEnabled && (
              <div className="PropertyInquiryModule__inquiry-details--helpcontent">
                <i className="fa fa-times" onClick={this.handleHideHelpText}/>
                Suggest some available times to tour the property. Click &quot;Suggest tour&quot; above to get started and contact the listing agent.
              </div>
              )}
            { leadAvailability && (
              <div className="PropertyInquiryModule__inquiry-details--availability">
              { `${referralName} is available ${leadAvailability.toLowerCase()}.` }
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  assignmentHash: selectAssignmentHash,
  assignmentTransactionHash: selectAssignmentTransactionHash,
  tourStatus: selectPropertyInquiryRequestedTourStatus,
  location: selectPropertyInquiryLocation,
  mlsNumber: selectPropertyInquiryMLSNumber,
  image: selectPropertyInquiryImage,
  tourOpId: selectPropertyInquiryTourOpId,
  link: selectPropertyInquiryRDCLink,
  title: selectPropertyInquiryTitle,
  isTourDateHidden: selectPropertyInquiryTourDateHidden,
  isTourConfirmable: selectIsPropertyInquiryTourConfirmable,
  isTourRescheduleable: selectIsPropertyInquiryTourRescheduleable,
  isTourSuggestable: selectIsPropertyInquiryTourSuggestable,
  isRDCLinkPresent: selectIsPropertyRDCLinkPresent,
  formattedTourDateTime: selectFormattedPropertyInquiryTourDateTime,
  suggestTourFeatureEnabled: selectManagerSuggestTourFeatureEnabled,
  openUrlFeatureEnabled: selectManagerOpenUrlFeatureEnabled,
  leadAvailability: selectReadableLeadAvailability,
  referralName: selectReferralName
})

const actions = { trackActivity }

export default connect(selector, actions)(PropertyInquiryModule)
